import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

export const CustomCursor = () => {
  const dotRef = useRef(null);
  const visibleRef = useRef(false);
  const [active, setActive] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const move = (e) => {
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
      }
      if (!visibleRef.current) {
        visibleRef.current = true;
        setVisible(true);
      }
      const t = e.target;
      const hit = t.closest && t.closest("a, button, [data-cursor], input, textarea, [role='button'], [role='slider']");
      const isActive = !!hit;
      setActive((prev) => (prev === isActive ? prev : isActive));
    };
    const leave = (e) => {
      if (e.relatedTarget === null && e.toElement === null) {
        visibleRef.current = false;
        setVisible(false);
      }
    };
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("pointermove", move, { passive: true });
    document.addEventListener("mouseout", leave);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("pointermove", move);
      document.removeEventListener("mouseout", leave);
    };
  }, []);

  return (
    <div
      ref={dotRef}
      aria-hidden
      style={{
        opacity: visible ? 1 : 0,
        transform: "translate3d(-100px,-100px,0)",
        willChange: "transform",
      }}
      className="pointer-events-none fixed left-0 top-0 z-[110] hidden md:block transition-opacity duration-100"
    >
      <motion.div
        animate={{
          width: active ? 44 : 18,
          height: active ? 44 : 18,
          backgroundColor: active ? "rgba(27,54,249,0.18)" : "rgba(27,54,249,0)",
          borderColor: active ? "#1B36F9" : "rgba(255,255,255,0.95)",
        }}
        transition={{ duration: 0.18, ease: [0.22, 1, 0.36, 1] }}
        style={{
          boxShadow: active ? "0 0 0 1px rgba(27,54,249,0.25)" : "0 0 0 1px rgba(0,0,0,0.35), 0 0 10px rgba(0,0,0,0.2)",
        }}
        className="rounded-full border-2 -translate-x-1/2 -translate-y-1/2"
      />
    </div>
  );
};
